import { toDateOnlyString, type DateOnlyInput } from "./organization.utils";

export type OrganizationListKeyParams = {
  keyword?: string | null;
  isActive?: boolean | null;
  from?: DateOnlyInput;
  to?: DateOnlyInput;
  pageNumber?: number;
  pageSize?: number;
};

export type OrganizationStatsKeyParams = {
  id: number;
  from?: DateOnlyInput;
  to?: DateOnlyInput;
  groupBy?: string | null;
};

export type OrganizationAppointmentsKeyParams = {
  id: number;
  organizationId: number;
  status?: string | number | null;
  from?: DateOnlyInput;
  to?: DateOnlyInput;
  pageNumber?: number;
  pageSize?: number;
};

export const organizationKeys = {
  all: ["organizations"] as const,
  listBase: () => [...organizationKeys.all, "list"] as const,
  list: (params: OrganizationListKeyParams) =>
    [...organizationKeys.listBase(), normalizeListParams(params)] as const,
  statsBase: (id: number) =>
    [...organizationKeys.all, "stats", id] as const,
  stats: (params: OrganizationStatsKeyParams) =>
    [...organizationKeys.statsBase(params.id), normalizeStatsParams(params)] as const,
  appointmentsBase: (id: number) =>
    [...organizationKeys.all, "appointments", id] as const,
  appointments: (params: OrganizationAppointmentsKeyParams) =>
    [
      ...organizationKeys.appointmentsBase(params.id),
      normalizeAppointmentsParams(params),
    ] as const,
  resolveLink: (token?: string | null) =>
    [...organizationKeys.all, "resolve-link", token ?? ""] as const,
};

function normalizeListParams(params: OrganizationListKeyParams) {
  return {
    keyword: params.keyword ?? undefined,
    isActive: params.isActive ?? undefined,
    from: toDateOnlyString(params.from),
    to: toDateOnlyString(params.to),
    pageNumber: params.pageNumber ?? undefined,
    pageSize: params.pageSize ?? undefined,
  };
}

function normalizeStatsParams(params: OrganizationStatsKeyParams) {
  return {
    from: toDateOnlyString(params.from),
    to: toDateOnlyString(params.to),
    groupBy: params.groupBy ?? undefined,
  };
}

function normalizeAppointmentsParams(params: OrganizationAppointmentsKeyParams) {
  return {
    organizationId: params.organizationId,
    status: params.status ?? undefined,
    from: toDateOnlyString(params.from),
    to: toDateOnlyString(params.to),
    pageNumber: params.pageNumber ?? undefined,
    pageSize: params.pageSize ?? undefined,
  };
}